import { observer, Provider } from 'mobx-react';
import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { RouteController } from './_controllers/RouteController';
import { ApplicationStore } from './_stores/ApplicationStore';
import './styles/App.css';
import * as styles from './styles/styleObjects';

console.log('TightKnit v0.6.0 rev. 1');

const store = new ApplicationStore();

@observer
export class App extends React.Component {
    public render() {
        return (
            <Provider store={store}>
                <Router>
                    <div style={styles.fullContainer}>
                        <RouteController store={store} />
                    </div>
                </Router>
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.tsx